import { Language } from 'common/utils';

import { ApplicationUser } from '../ApplicationUsers/models/application-user';

export enum NotificationReceiversType {
  ALL_USERS = 'all_users',
  SELECTED_USERS = 'selected_users',
}

export enum EmailInputType {
  SELECT = 'select',
  TEXT = 'text',
}

export enum NotificationType {
  DEFAULT = 'DEFAULT',
  IN_APP = 'IN_APP',
}

export enum OtherNotificationIgnoreSettingType {
  ALL_USERS = 'ALL_USERS',
  ACTIVATED_USERS = 'ACTIVATED_USERS',
}

export type NotificationsForm = {
  notificationReceiversType: NotificationReceiversType;
  notificationType: NotificationType;
  title_en: string;
  title_de: string;
  title_fr: string;
  title_nl: string;
  title_sv: string;
  title_da: string;
  title_fi: string;
  title_no: string;
  title_pl: string;
  title_it: string;
  body_en: string;
  body_de: string;
  body_fr: string;
  body_nl: string;
  body_sv: string;
  body_da: string;
  body_fi: string;
  body_no: string;
  body_pl: string;
  body_it: string;
  emailInputType: EmailInputType;
  inputMailList: string;
  selectedUsersList: ApplicationUser[];
  link_en: string;
  link_de: string;
  link_fr: string;
  link_nl: string;
  link_sv: string;
  link_da: string;
  link_fi: string;
  link_no: string;
  link_pl: string;
  link_it: string;
  buttonText_en: string;
  buttonText_de: string;
  buttonText_fr: string;
  buttonText_nl: string;
  buttonText_sv: string;
  buttonText_da: string;
  buttonText_fi: string;
  buttonText_no: string;
  buttonText_pl: string;
  buttonText_it: string;
  image: string;
  temporaryImage?: FileList;
  otherNotificationIgnoreSettingType: OtherNotificationIgnoreSettingType;
};

export type InternationalisedContent = {
  [key in Language]: string;
};

export type SendNotificationsRequest = {
  title: InternationalisedContent;
  body: InternationalisedContent;
  buttonText: InternationalisedContent;
  link?: InternationalisedContent;
  userEmails?: string[];
  type: NotificationType;
  image?: File;
};
